import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const Root = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.general.lightGrey8,
  marginBottom: theme.spacing(2),
  paddingRight: theme.spacing(5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  height: '70px',

  '.MuiIconButton-root': {
    backgroundColor: theme.palette.general.lightGrey3,
    borderRadius: 0,
    padding: theme.spacing(2.5),
    height: '70px',
    width: '70px',
    color: theme.palette.common.black,

    '&:hover': {
      backgroundColor: theme.palette.general.lightGrey3,
    },
  },
}));
